(function () {
    'use strict';

    angular
        .module('adm')
        .config(AdmProcessRoute);

    AdmProcessRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function AdmProcessRoute ($stateProvider) {
        $stateProvider
            .state('root.adm.process', {
                abstract: true,
                url: '/process',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state('root.adm.process.list', {
                url:'/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/adm/process/list/list.html',
                        controller: 'AdmProcessListController',
                        controllerAs: 'admProcessList'
                    }
                }
            })
            .state('root.adm.process.create', {
                url:'/create',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/adm/process/create/form.html',
                        controller: 'AdmProcessCreateController',
                        controllerAs: 'admProcessCreate'
                    }
                }
            });
    }
})();